// extracted by mini-css-extract-plugin
module.exports = {"ctoButton":"CellularCapability_ctoButton__5jHe5","noHoverBg":"CellularCapability_noHoverBg__1Uicy"};